import { render, staticRenderFns } from "./ItemFilterTagList.vue?vue&type=template&id=6da91432&"
import script from "./ItemFilterTagList.vue?vue&type=script&lang=js&"
export * from "./ItemFilterTagList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/plugin-ceres/plugin-ceres/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6da91432')) {
      api.createRecord('6da91432', component.options)
    } else {
      api.reload('6da91432', component.options)
    }
    module.hot.accept("./ItemFilterTagList.vue?vue&type=template&id=6da91432&", function () {
      api.rerender('6da91432', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/itemList/filter/ItemFilterTagList.vue"
export default component.exports